import { ApplicationRef, ComponentRef, createComponent, EmbeddedViewRef, EnvironmentInjector, inject, Injectable } from '@angular/core';
import { ScorecardsV2DescriptionComponent } from './scorecards-v2-description/scorecards-v2-description.component';

/** Opens the scorecard (v2) description panel on top of the page, one at a time. */
@Injectable({ providedIn: 'root' })
export class ScorecardsV2DescriptionService {
  private appRef = inject(ApplicationRef);
  private environmentInjector = inject(EnvironmentInjector);
  private componentRef: ComponentRef<ScorecardsV2DescriptionComponent> | null = null;

  /** Opens the panel for the given scorecard. The linked chain and parent are read from the ScorecardV2Store. */
  open(scorecardId: number): void {
    this.close();

    const ref = createComponent(ScorecardsV2DescriptionComponent, {
      environmentInjector: this.environmentInjector,
    });

    ref.setInput('scorecardId', scorecardId);
    ref.instance.closed.subscribe(() => this.close());

    this.appRef.attachView(ref.hostView);
    const domNode = (ref.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domNode);
    ref.changeDetectorRef.detectChanges();

    this.componentRef = ref;
  }

  close(): void {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
